var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAsset6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 301,
    height: 222,
    viewBox: "0 0 301 222",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M288.662 64.2305C288.662 64.2305 287.756 57.8049 285.953 53.1276L281.211 59.5632L288.667 64.2305H288.662Z",
    fill: "#FFF7D3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M205.523 142.315C199.313 140.203 195.918 132.323 189.524 129.289C177.851 123.75 165.132 133.473 168.507 146.385C171.912 159.415 187.035 162.613 185.688 173.636C185.172 177.836 185.027 181.955 185.893 185.98H214.306L205.523 142.315Z",
    fill: "#D9D6E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9702 73.6891C89.5581 66.3768 102.513 71.7116 102.608 83.3725C102.703 95.1379 92.4524 97.509 96.1029 106.51C97.495 109.937 99.2727 118.245 94.9962 125.095L80.9702 115.999V73.6891Z",
    fill: "#F9F8F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M208.001 102.799C202.367 103.99 197.78 108.502 196.473 116.044C194.175 129.314 209.288 137.034 204.696 147.156C198.922 159.868 198.371 173.721 214.31 185.979L241.381 186.258V116.881C241.381 116.881 238.031 117.658 232.017 115.835C232.017 115.835 232.197 119.914 230.92 121.817C229.648 123.715 226.298 124.716 221.877 124.173L222.763 121.991C222.763 121.991 221.506 122.664 220.099 122.206L224.536 113.573C224.536 113.573 217.235 110.634 211.977 106.166L208.001 102.794V102.799Z",
    fill: "#F9F8F4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M104.776 152.297C104.776 152.297 105.552 171.798 89.9089 186.258H80.9004V148.91C89.5133 151.485 99.8889 152.147 99.8889 152.147L104.776 152.302V152.297Z",
    fill: "#EBEAF4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M103.499 141.055C103.499 141.055 101.962 134.619 99.0677 129.533C96.3837 124.811 90.1594 116.951 80.8955 111.87V141.259C80.8955 141.259 93.6596 143.959 103.499 141.055Z",
    fill: "#EBEAF4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M224.536 113.574C217.871 111.273 208.181 105.22 201.742 94.3765C201.742 94.3765 225.147 93.2109 232.548 71.2291C232.548 71.2291 235.537 77.1019 238.312 80.1753V113.39L225.252 112.094L224.536 113.574Z",
    fill: "#FFF7D3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M233.57 43.2398V39.6434C223.009 40.7393 221.111 28.1868 221.111 28.1868C221.111 28.1868 198.061 37.4916 195.052 66.3424H220.099L233.57 43.2398Z",
    fill: "#FFF7D3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M164.05 66.3474L173.229 72.2202L168.396 80.3544C168.396 80.3544 173.484 82.2721 174.601 74.9548L176.529 74.3322L181.03 77.2113L163.895 103.711L149.278 94.3614C149.278 94.3614 152.002 93.2257 151.296 88.4986C151.296 88.4986 161.196 88.7875 160.314 82.4515L152.202 84.6731L164.055 66.3474H164.05Z",
    fill: "#DBD8E6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M187.15 69.2263C187.15 69.2263 185.708 74.0879 185.708 81.3853C185.708 88.6827 188.116 95.0685 191.276 95.0685C194.436 95.0685 196.844 89.0413 196.844 80.7079C196.844 72.3744 195.006 70.0482 195.006 70.0482L187.15 69.2263Z",
    fill: "#A49DC1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M142.283 114.057C142.283 114.057 144.511 118.022 147.941 121.753C151.371 125.484 157.41 129.479 159.644 126.854C161.877 124.223 158.212 116.518 153.675 111.422C149.138 106.321 144.291 103.96 144.291 103.96L142.288 114.062L142.283 114.057Z",
    fill: "#A49DC1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8955 111.865C79.0728 110.814 77.0597 109.818 74.8865 108.936C78.562 118.789 78.1664 126.111 75.207 129.613C72.1123 133.274 67.2851 131.241 67.2851 131.241C67.5054 134.634 66.7393 137.099 66.4839 137.817L80.8955 141.254V111.865Z",
    fill: "#EBEAF4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9979 123.541C52.0524 124.148 49.9142 116.403 49.9142 116.403L48.0064 105.992C40.6854 107.357 33.1541 110.684 26.0184 116.881C6.51417 133.827 10.5652 157.447 10.5652 157.447L42.8987 132.198L60.395 136.372C61.4115 129.732 58.9979 123.546 58.9979 123.546V123.541Z",
    fill: "#EBEAF4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M238.312 48.1312C236.85 47.6431 235.382 46.9557 234.326 45.028C231.081 39.1153 235.327 32.8441 236.684 24.5554C238.041 16.2668 236.539 9.04414 236.539 9.04414C236.539 9.04414 236.149 14.364 234.456 15.6242C232.763 16.8845 230.46 16.3913 227.891 15.4549C224.872 14.354 221.406 13.2183 217.065 14.6928C217.065 14.6928 222.188 0.899963 235.442 0.899963C240.645 0.899963 244.166 3.02193 247.43 6.59342C250.976 10.4737 253.565 12.4313 257.966 13.0938C262.368 13.7563 267.836 17.2082 269.438 22.4484C271.041 27.6886 273.575 29.681 279.574 32.6896C285.578 35.6983 287.576 41.4913 287.576 47.0652C287.576 52.6391 284.751 61.934 272.768 61.2615C261.507 60.6289 256.89 52.0962 257.961 44.9981L238.312 32.6896V48.1312Z",
    fill: "#0E090C"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2879 123.227C58.2814 121.419 57.4001 119.939 57.4001 119.939C57.4001 119.939 56.5788 122.39 53.7546 120.607C50.9304 118.818 49.388 114.525 51.341 113.195C53.2939 111.865 56.1682 115.685 56.1682 115.685C54.726 109.374 50.4647 105.882 50.4647 105.882C50.4647 105.882 54.3555 106.226 56.2934 105.125C60.9504 102.475 58.9924 99.0682 65.6374 98.9188C72.2824 98.7694 73.9449 92.0448 69.9288 87.8457C65.9128 83.6466 61.2058 86.0575 59.6635 87.8457C58.1161 89.634 56.5037 90.8045 54.2203 91.4969C51.9369 92.1843 47.37 92.0498 45.6374 95.0086C43.9048 97.9674 44.4607 101.066 45.8427 103.203C47.2248 105.335 47.1597 107.262 45.9829 108.846C44.8062 110.43 43.354 112.218 43.2839 114.146C43.2138 116.074 44.3204 117.384 46.659 117.797C48.9975 118.211 49.5783 119.795 49.9939 120.607C50.4096 121.419 50.9654 124.955 54.5558 125.578C56.1031 125.847 58.5167 125.15 59.0575 123.326L59.2829 123.232L59.2879 123.227Z",
    fill: "#0E090C"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M241.381 116.881C241.381 116.881 254.596 117.309 265.647 110.525L259.453 103.955H241.376V116.881H241.381Z",
    fill: "#FFF7D3"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3663 64.2106C99.7183 64.2106 106.489 57.4756 106.489 49.1676C106.489 40.8595 99.7183 34.1245 91.3663 34.1245C83.0143 34.1245 76.2437 40.8595 76.2437 49.1676C76.2437 57.4756 83.0143 64.2106 91.3663 64.2106Z",
    fill: "#FFF7D3"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M220.485 15.4847C220.485 15.4847 219.148 21.5667 221.467 29.5067C223.72 37.2225 228.407 40.1215 232.253 39.5835",
    stroke: "#0E090C",
    strokeWidth: 0.251775,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M226.173 22.4483L225.567 28.1916H227.58",
    stroke: "#0E090C",
    strokeWidth: 0.251775,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M232.397 21.004C232.397 21.004 231.1 23.1559 229.458 21.024",
    stroke: "#0E090C",
    strokeWidth: 0.251775,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M224.335 21.5568C224.335 21.5568 223.164 23.6339 221.812 21.4272",
    stroke: "#0E090C",
    strokeWidth: 0.251775,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M241.381 175.469L210.074 115.686",
    stroke: "#0E090C",
    strokeWidth: 0.251775,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M230.655 130.594L223.945 142.175",
    stroke: "#0E090C",
    strokeWidth: 0.251775,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M233.474 160.372L211.341 161.577",
    stroke: "#0E090C",
    strokeWidth: 0.251775,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M200.995 162.165L181.882 140.94",
    stroke: "#0E090C",
    strokeWidth: 0.251775,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M195.232 156.391L185.708 156.077",
    stroke: "#0E090C",
    strokeWidth: 0.251775,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M187.826 147.54L188.346 139.321",
    stroke: "#0E090C",
    strokeWidth: 0.251775,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9702 99.736L90.0789 81.7989",
    stroke: "#0E090C",
    strokeWidth: 0.251775,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9038 96.2439L90.8657 93.828",
    stroke: "#0E090C",
    strokeWidth: 0.251775,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5688 88.7127L84.2554 81.8936",
    stroke: "#0E090C",
    strokeWidth: 0.251775,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M206.659 178.478L195.983 179.808",
    stroke: "#0E090C",
    strokeWidth: 0.251775,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M281.211 59.563L288.662 64.2304",
    stroke: "#0E090C",
    strokeWidth: 0.251775,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M222.768 121.992C221.451 122.704 220.104 122.206 220.104 122.206L225.257 112.184L238.316 113.395V32.69L257.966 44.9984",
    stroke: "#0E090C",
    strokeWidth: 0.251775,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M226.694 112.314L221.877 124.169C221.877 124.169 226.629 125.006 229.794 122.938C231.391 121.892 232.012 119.955 232.012 116.184",
    stroke: "#0E090C",
    strokeWidth: 0.251775,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M228.627 112.493L224.907 124.338",
    stroke: "#0E090C",
    strokeWidth: 0.251775,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M230.655 112.682L228.262 123.695",
    stroke: "#0E090C",
    strokeWidth: 0.251775,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M127.195 186.259H80.896",
    stroke: "#0E090C",
    strokeWidth: 0.251775,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M214.311 185.979C214.311 185.979 206.479 181.008 202.503 171.026",
    stroke: "#0E090C",
    strokeWidth: 0.251775,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M241.381 103.955V125.951",
    stroke: "#0E090C",
    strokeWidth: 0.251775,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M238.312 103.955H271.091L243.935 41.0328",
    stroke: "#0E090C",
    strokeWidth: 0.251775,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M233.57 43.2399L220.099 66.3424H171.291L169.814 68.7533",
    stroke: "#0E090C",
    strokeWidth: 0.251775,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M191.276 66.3425C194.35 66.3425 196.844 72.7731 196.844 80.7031",
    stroke: "#0E090C",
    strokeWidth: 0.251775,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M139.899 102.799C138.667 106.645 140.92 113.3 145.928 119.471",
    stroke: "#0E090C",
    strokeWidth: 0.251775,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M195.006 70.0431L179.533 68.4292C179.533 68.4292 180.45 73.8288 174.601 74.9495C174.601 74.9495 173.755 82.0327 168.396 80.3491L174.811 69.55",
    stroke: "#0E090C",
    strokeWidth: 0.251775,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M259.453 103.955C261.486 106.122 263.299 108.044 265.647 110.525",
    stroke: "#0E090C",
    strokeWidth: 0.251775,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M232.017 49.1673C232.017 49.1673 228.973 56.8881 230.931 65.7047C231.927 70.1977 233.279 73.6745 238.312 80.17",
    stroke: "#0E090C",
    strokeWidth: 0.251775,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M191.276 95.0685C207.155 95.0685 224.711 91.1484 232.017 72.494",
    stroke: "#0E090C",
    strokeWidth: 0.251775,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M232.017 115.835C235.217 116.517 238.542 116.881 241.947 116.881C267.951 116.881 289.033 95.9104 289.033 70.0433C289.033 68.0758 288.912 66.1331 288.672 64.2303C288.372 61.8344 287.891 59.4933 287.245 57.2219",
    stroke: "#0E090C",
    strokeWidth: 0.251775,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M174.005 156.232C173.85 156.621 173.7 157.004 173.555 157.393",
    stroke: "#EA5599",
    strokeWidth: 0.251775,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M172.753 159.734C171.467 163.813 170.735 168.052 170.425 172.804C168.707 199.289 185.703 219.622 215.673 220.857C242.328 221.958 267.07 201.69 263.97 169.875C261.942 146.643 262.864 135.56 273.469 125.423C282.318 116.966 293.239 117.16 298.036 117.758",
    stroke: "#EA5599",
    strokeWidth: 0.251775,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M299.273 117.942C300.059 118.077 300.5 118.186 300.5 118.186",
    stroke: "#EA5599",
    strokeWidth: 0.251775,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M141.161 144.178C141.256 154.205 137.931 166.578 125.928 173.009",
    stroke: "#EA5599",
    strokeWidth: 0.251775,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M152.488 81.5894H146.534C146.534 81.5894 146.379 82.3715 138.998 105.643C131.617 128.915 109.008 147.819 80.2696 141.259C51.5365 134.698 42.8986 132.198 42.8986 132.198L0.5 165.308",
    stroke: "#0E090C",
    strokeWidth: 0.251775,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M159.643 126.849C159.643 126.849 133.189 163.276 80.9004 148.905V186.254",
    stroke: "#0E090C",
    strokeWidth: 0.251775,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9178 141.587L20.355 181.003",
    stroke: "#0E090C",
    strokeWidth: 0.251775,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M180.29 119.402C185.218 119.402 189.213 115.428 189.213 110.525C189.213 105.623 185.218 101.649 180.29 101.649C175.362 101.649 171.367 105.623 171.367 110.525C171.367 115.428 175.362 119.402 180.29 119.402Z",
    stroke: "#0E090C",
    strokeWidth: 0.251775,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M118.912 98.2166C122.439 98.2166 125.297 95.3732 125.297 91.8657C125.297 88.3581 122.439 85.5147 118.912 85.5147C115.386 85.5147 112.528 88.3581 112.528 91.8657C112.528 95.3732 115.386 98.2166 118.912 98.2166Z",
    stroke: "#0E090C",
    strokeWidth: 0.251775,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7801 140.412C30.7801 140.412 13.7847 131.959 13.7847 107.237C13.7847 90.4409 23.8047 78.4662 38.9173 72.4938C56.5638 65.5152 71.6013 70.0331 82.5177 61.8989C93.4341 53.7647 93.1186 39.8324 89.373 32.9584C85.6774 26.1741 77.1246 19.7833 65.9979 22.4482C55.8577 24.879 49.7736 32.7094 48.8873 41.0329",
    stroke: "#EA5599",
    strokeWidth: 0.251775,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M80.896 111.432V72.494",
    stroke: "#0E090C",
    strokeWidth: 0.251775,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M147.761 85.8884L160.315 82.4514C160.315 82.4514 162.077 88.2146 151.296 88.4985C151.296 88.4985 152.778 95.1683 146.048 95.0687L142.283 114.057",
    stroke: "#0E090C",
    strokeWidth: 0.251775,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M54.561 135.196L57.19 143.619L63.5245 137.363L65.5976 145.398L72.8234 139.54",
    stroke: "#0E090C",
    strokeWidth: 0.251775,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5243 137.363C63.5243 137.363 63.364 141.328 61.0606 144.586C58.7571 147.844 57.9359 150.987 58.9023 156.078C59.8688 161.168 59.6485 166.144 55.7025 170.359C51.7566 174.573 50.5648 178.697 51.4612 186.263C52.3525 193.825 50.8653 198.064 46.3986 202.646C41.9319 207.229 41.336 212.041 41.4111 214.706",
    stroke: "#0E090C",
    strokeWidth: 0.251775,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M198.092 55.4784C198.092 55.4784 214.682 53.9094 215.282 36.1267C215.823 19.9628 201.291 15.4848 196.359 15.4848C183.665 15.4848 174.907 24.3662 174.106 35.4841C173.304 46.602 181.301 51.1697 187.696 45.4065C194.091 39.6483 191.827 26.9514 190.23 21.0039C188.688 15.2606 184.036 5.72672 172.804 1.35327",
    stroke: "#EA5599",
    strokeWidth: 0.251775,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9659 117.513L73.4296 116.363L69.2383 109.424",
    stroke: "#0E090C",
    strokeWidth: 0.251775,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2383 109.424C69.2383 109.424 70.0345 106.615 72.9739 107.88",
    stroke: "#0E090C",
    strokeWidth: 0.251775,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9782 110.53C65.9782 110.53 62.9587 108.199 61.2061 112.901",
    stroke: "#0E090C",
    strokeWidth: 0.251775,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3989 138.041C66.3989 138.041 67.6658 134.888 67.1701 131.192",
    stroke: "#0E090C",
    strokeWidth: 0.251775,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3598 136.606C60.3598 136.606 61.6868 130.171 58.6772 122.629C60.5701 126.131 64.5511 131.804 70.4499 131.804C78.9777 131.804 80.52 118.166 70.4499 98.9139",
    stroke: "#0E090C",
    strokeWidth: 0.251775,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M151.176 91.8805L167.761 87.3626L164.476 68.7531",
    stroke: "#0E090C",
    strokeWidth: 0.251775,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9093 186.258C89.9093 186.258 86.399 189.785 80.9008 192.808C74.1707 196.509 66.0235 198.96 57.5107 198.96C34.6915 198.96 15.648 182.871 11.2163 161.477",
    stroke: "#0E090C",
    strokeWidth: 0.251775,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7716 151.047C62.3911 151.047 62.8933 150.547 62.8933 149.931C62.8933 149.315 62.3911 148.815 61.7716 148.815C61.1521 148.815 60.6499 149.315 60.6499 149.931C60.6499 150.547 61.1521 151.047 61.7716 151.047Z",
    stroke: "#0E090C",
    strokeWidth: 0.251775,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5611 178.991C55.1806 178.991 55.6828 178.491 55.6828 177.875C55.6828 177.259 55.1806 176.759 54.5611 176.759C53.9416 176.759 53.4395 177.259 53.4395 177.875C53.4395 178.491 53.9416 178.991 54.5611 178.991Z",
    stroke: "#0E090C",
    strokeWidth: 0.251775,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5377 210.751C46.1572 210.751 46.6594 210.251 46.6594 209.635C46.6594 209.019 46.1572 208.519 45.5377 208.519C44.9182 208.519 44.416 209.019 44.416 209.635C44.416 210.251 44.9182 210.751 45.5377 210.751Z",
    stroke: "#0E090C",
    strokeWidth: 0.251775,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9736 122.027C72.9736 122.027 68.5018 122.848 66.8394 121.568",
    stroke: "#0E090C",
    strokeWidth: 0.251775,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6058 111.661C65.0787 111.661 65.4621 111.28 65.4621 110.809C65.4621 110.339 65.0787 109.957 64.6058 109.957C64.1329 109.957 63.7495 110.339 63.7495 110.809C63.7495 111.28 64.1329 111.661 64.6058 111.661Z",
    fill: "#0E090C"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5965 109.34C72.0694 109.34 72.4528 108.958 72.4528 108.488C72.4528 108.017 72.0694 107.636 71.5965 107.636C71.1236 107.636 70.7402 108.017 70.7402 108.488C70.7402 108.958 71.1236 109.34 71.5965 109.34Z",
    fill: "#0E090C"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M226.574 31.7881C226.574 31.7881 229.819 32.0173 230.931 31.0958",
    stroke: "#0E090C",
    strokeWidth: 0.251775,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M209.613 185.979H225.727",
    stroke: "#0E090C",
    strokeWidth: 0.251775,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M175.467 106.167C175.467 106.167 182.758 119.401 177.766 134.823C175.663 141.318 166.674 160.371 137.505 156.386C127.335 154.997 118.282 148.71 114.185 140.103C108.637 128.442 112.989 118.042 121.617 117.509C124.711 117.319 127.716 118.33 130.395 120.183",
    stroke: "#EA5599",
    strokeWidth: 0.251775,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset6);
export default __webpack_public_path__ + "static/media/Asset6.d43b7212c69555a7b4db8e83bb8d0778.svg";
export { ForwardRef as ReactComponent };